import { createClient } from "@supabase/supabase-js";
export const supabaseUrl = 'https://yogepzfqyiwcidjmetro.supabase.co';
export const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlvZ2VwemZxeWl3Y2lkam1ldHJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgwMzMxMDgsImV4cCI6MjA4MzYwOTEwOH0.bMRMRFWj_T4rY7eKdwZVbxmiop9NcgPV6nFYNV-l57s';


export const supabase = createClient(supabaseUrl, supabaseKey);